import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AppAccordion, AppAccordionSummary } from './primitives/AppAccordion';
import { connect } from 'react-redux';
import translationService from '../services/translator.service';

export function AccordionComponent({
    title,
    options,
    leftAtach,
    rightAtach,
    TransitionProps,
    keyIndex,
    expanded,
    accordionExpandedParts,
    setAccordionExpandedParts,
    languageReducer,
    borderVariant,
    compactSpacing,
    leftAtachPadding,
    titleFontSizePx,
    disabled = false,
    showExpandIcon = true,
    canExpand = true,
}) {
    const classes = useStyles({ borderVariant, compactSpacing, leftAtachPadding, titleFontSizePx });
    const translatedData = translationService.getTranslatedData(languageReducer.language);
    const isControlled = Boolean(accordionExpandedParts && setAccordionExpandedParts);
    const isExpanded = isControlled ? Boolean(accordionExpandedParts[`${keyIndex}`]) : Boolean(expanded);

    return (
        <div className={classes.root}>
            <AppAccordion
                key={keyIndex}
                TransitionProps={TransitionProps}
                borderVariant={borderVariant}
                square={true}
                expanded={isExpanded}
                disabled={disabled}
                onChange={(e, expandedState) => {
                    if (!canExpand) {
                        return;
                    }

                    if (isControlled) {
                        setAccordionExpandedParts((prev) => ({
                            ...(prev || {}),
                            [`${keyIndex}`]: expandedState,
                        }));
                    }
                }}>
                <AppAccordionSummary className={classes.row} expandIcon={showExpandIcon ? <ExpandMoreIcon /> : null} aria-label={translationService.getTranslation(translatedData, 'general.a11y.expand')} aria-controls='additional-actions1-content' id='additional-actions1-header'>
                    <Box className={classes.leftAtach} onClick={(event) => event.stopPropagation()} onFocus={(event) => event.stopPropagation()}>
                        {leftAtach}
                    </Box>
                    <Typography className={classes.heading}>{title}</Typography>
                </AppAccordionSummary>
                <>{options}</>
                {/* <AppAccordionDetails className={classes.AccordionDetails}>{options}</AppAccordionDetails> */}
            </AppAccordion>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: (props) => (props.compactSpacing ? theme.spacing(0.25) : '1vh'),
    },
    heading: {
        fontSize: (props) => theme.typography.pxToRem(props.titleFontSizePx || 15),
        fontWeight: 'bold',
    },
    AccordionDetails: {
        display: 'flex',
        flexDirection: 'column',
        borderStyle: (props) => (props.borderVariant === 'bottom-when-collapsed' ? 'solid' : 'none'),
        borderWidth: (props) => (props.borderVariant === 'bottom-when-collapsed' ? 1.5 : 0),
        borderColor: (props) => (props.borderVariant === 'bottom-when-collapsed' ? theme.palette.divider : 'transparent'),
        borderRadius: 0,
        marginTop: (props) => (props.borderVariant === 'bottom-when-collapsed' ? theme.spacing(0.75) : 0),
        marginBottom: (props) => (props.borderVariant === 'bottom-when-collapsed' ? theme.spacing(0.25) : 0),
        paddingTop: (props) => (props.borderVariant === 'bottom-when-collapsed' ? theme.spacing(0.75) : undefined),
        paddingBottom: (props) => (props.borderVariant === 'bottom-when-collapsed' ? theme.spacing(0.75) : undefined),
    },
    row: {
        display: 'flex',
        justifyContent: 'space-evenly',
        borderBottom: (props) => (props.borderVariant === 'bottom-when-collapsed' ? `1.5px solid ${theme.palette.divider}` : 'none'),
        '&.Mui-expanded': {
            borderBottom: (props) => (props.borderVariant === 'bottom-when-collapsed' ? `1.5px solid ${theme.palette.divider}` : 'none'),
        },
    },
    leftAtach: {
        paddingLeft: (props) => props.leftAtachPadding,
        display: 'flex',
        flexShrink: 1,
        color: 'inherit',
    },
}));

const mapStateToProps = (state) => ({
    languageReducer: state.languageReducer,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AccordionComponent);
